import React from "react";
import { X, AlertTriangle, Package, Truck } from "lucide-react";

export default function DelayedShippingModal({ po, shipment, delayedItems, onClose }) {
  if (!po) return null;

  const fmtCurrency = (v) =>
    Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: "640px" }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2><AlertTriangle size={20} className="notif-icon-warn" /> Delayed Shipping — {po.poNumber}</h2>
          <button className="modal-close-btn" onClick={onClose}><X size={20} /></button>
        </div>

        <div className="modal-body">
          {/* PO Summary */}
          <div className="dsh-po-summary">
            <div className="dsh-po-row">
              <span className="dsh-po-label">PO Number</span>
              <span className="dsh-po-value">{po.poNumber}</span>
            </div>
            {po.title && (
              <div className="dsh-po-row">
                <span className="dsh-po-label">Project</span>
                <span className="dsh-po-value">{po.title}</span>
              </div>
            )}
            <div className="dsh-po-row">
              <span className="dsh-po-label">Client</span>
              <span className="dsh-po-value">{po.clientName || "—"}</span>
            </div>
            {shipment && (
              <>
                <div className="dsh-po-row">
                  <span className="dsh-po-label">Carrier</span>
                  <span className="dsh-po-value">{shipment.carrier || "—"}</span>
                </div>
                <div className="dsh-po-row">
                  <span className="dsh-po-label">Route</span>
                  <span className="dsh-po-value">{shipment.origin || "—"} → {shipment.destination || "—"}</span>
                </div>
              </>
            )}
          </div>

          {/* Delayed Items Table */}
          <h4 className="dsh-section-title"><Package size={16} /> Delayed Items</h4>
          <div className="log-items-table-wrap">
            <table className="log-items-table">
              <thead>
                <tr>
                  <th>Item Description</th>
                  <th>Qty</th>
                  <th>Status</th>
                  <th>Purchased Date</th>
                  <th>Days Delayed</th>
                </tr>
              </thead>
              <tbody>
                {delayedItems.map((item, i) => (
                  <tr key={i}>
                    <td className="log-td-primary">{item.description || "Unnamed Item"}</td>
                    <td>{item.quantity || 0}</td>
                    <td><span className="log-item-status-badge" style={{ color: "var(--warning)" }}>Purchased</span></td>
                    <td>{item.purchasedDate || "—"}</td>
                    <td><span className="dsh-days-badge">{item.daysDiff} days</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
